import { IOperativeUserRole } from '@app/interfaces';
import { User } from '@auth0/auth0-angular';

export class UserModel {
	private readonly _roles: IOperativeUserRole[];
	private readonly _role: IOperativeUserRole;
	private readonly _isEmailVerified: boolean;
	private readonly _organizationId: string;
	private readonly _whiteLabel: string;
	private readonly _resellerId: string;
	private readonly _nickname: string;
	private readonly _company: string;
	private readonly _email: string;
	private readonly _id: string;

	private readonly _userName: string;
	private readonly _profile: string;

	constructor(user: User) {
		this._isEmailVerified = user.email_verified;
		this._nickname = user.nickname;
		this._profile = user.profile;
		this._email = user.email;

		this._roles = this.getRoleFromMetadata(user);
		this._role = this._roles[0];

		const metadata = this.getMetadata(user);
		this._whiteLabel = metadata.white_label;
		this._resellerId = metadata.reseller_id;
		this._organizationId = metadata.org_id;
		this._userName = metadata.username;
		this._company = metadata.company;
		this._id = metadata.user_uuid;
	}

	public get isEmailVerified(): boolean {
		return this._isEmailVerified;
	}

	public get userName(): string {
		return this._userName;
	}

	public get organizationId(): string {
		return this._organizationId;
	}

	public get whiteLabel(): string {
		return this._whiteLabel;
	}

	public get resellerId(): string {
		return this._resellerId;
	}

	public get nickname(): string {
		return this._nickname;
	}

	public get company(): string {
		return this._company;
	}

	public get profile(): string {
		return this._profile;
	}

	public get role(): IOperativeUserRole {
		return this._role;
	}

	public get email(): string {
		return this._email;
	}

	public get id(): string {
		return this._id;
	}

	private getRoleFromMetadata(user: User): IOperativeUserRole[] {
		const roleMetadataKey = Object.keys(user).find((x) => x.endsWith('/roles'));
		return user[roleMetadataKey];
	}

	private getMetadata(user: User): IUserMetadata {
		const roleMetadataKey = Object.keys(user).find((x) => x.endsWith('/user_metadata'));
		return user[roleMetadataKey];
	}
}

interface IUserMetadata {
	added_to_api: boolean;
	company: string;
	email: string;
	nickname: string;
	org_id: string;
	permissions: string;
	profile: string;
	user_uuid: string;
	username: string;
	white_label: string;
	email_verified: boolean;
	reseller_id?: string;
}
